import { height } from "../utilities/density";
import { filledInputFieldStyles, inputFieldStyles } from "../patterns/input-field";
const styles = {
    textField: Object.assign(Object.assign({}, inputFieldStyles()), { height: height() }),
    textField__filled: Object.assign({}, filledInputFieldStyles()),
};
export default styles;
